import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import {
  EmailControl,
  EmailRegExp,
} from '../../../models/controls/email-control';
import { OrderService } from '../../../services/order/order.service';
import { Validators } from '@angular/forms';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-email-control',
  templateUrl: './email-control.component.html',
  styleUrls: ['./email-control.component.scss'],
})
export class EmailControlComponent
  extends BaseControlComponent<EmailControl>
  implements OnInit, AfterViewInit {
  constructor(
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
  }

  ngAfterViewInit(): void {
    this.setValidators();
    super.ngAfterViewInit();
  }

  protected setValidators(): void {
    super.setValidators();
    this.validators.push(Validators.email);
    this.validators.push(Validators.pattern(EmailRegExp));
    this.ngModel?.control.setValidators(this.validators);
  }
}
